
import Header from '@/components/header/ModernHeader';
import Footer from "@/components/Footer";
import { SEO } from "@/components/SEO";
import BackButton from "@/components/navigation/BackButton";

const About = () => {
  return (
    <>
      <SEO title="About Us" description="Learn more about our company and mission." />
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="w-full px-4 md:px-8 lg:px-12 py-16">
          <div className="max-w-4xl mx-auto">
            <BackButton to="/" label="Back to Home" />
            <h1 className="text-4xl font-bold text-center mb-8">About Us</h1>
            <div className="prose prose-lg mx-auto">
              <p className="text-lg text-gray-600 mb-6">
                Welcome to our store! We are dedicated to providing high-quality products 
                and exceptional customer service.
              </p>
              <p className="text-gray-600 mb-6">
                Our mission is to make shopping easy, enjoyable, and accessible for everyone. 
                We carefully curate our product selection to ensure we offer only the best 
                items at competitive prices.
              </p>
              <p className="text-gray-600">
                Thank you for choosing us for your shopping needs. We look forward to 
                serving you and building a long-lasting relationship.
              </p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default About;
